import { Chip, CountStat, Rv } from '../../components'
import { HeroSphere }           from './HeroSphere'
import { TypingName }           from './TypingName'

/** Resume filename served from /public/ */
const RESUME_PATH     = '/Devamkumar_Patel_Resume.pdf'
const RESUME_FILENAME = 'Devamkumar_Patel_Resume.pdf'

export function HeroSection() {
  const chips = ['Java', 'Selenium', 'Appium', 'JMeter', 'REST Assured', 'Postman', 'Agile/Scrum']
  return (
    <main id="home" style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', paddingTop: '5.5rem', position: 'relative', zIndex: 1 }}>
      <div className="wrap">
        <div className="hg">

          <div className="rv in">
            <div className="eyb">QA Engineer · SDET · Monash University</div>
            <TypingName/>
            <p className="hr">
              Results-driven QA Engineer with 2+ years building Selenium-Java automation frameworks,
              executing API &amp; performance testing, and shipping high-quality software in Agile environments.
            </p>
            <div className="chips" style={{ marginTop: '1.4rem' }}>
              {chips.map(t => <Chip key={t} label={t}/>)}
            </div>
            <div className="hbtns">
              <a href="#projects"  className="btn bp">View Projects →</a>
              <a href="#contact"   className="btn bg-btn">Get in Touch</a>
              {/* ── Resume download ── */}
              <a
                href={RESUME_PATH}
                download={RESUME_FILENAME}
                className="btn resume-btn"
                aria-label="Download resume PDF"
              >
                <span className="resume-icon">⬇</span> Resume
              </a>
            </div>
          </div>

          <div className="hero-r rv in" style={{ transitionDelay: '.2s' }}>
            <div className="canvas-glass"><HeroSphere/></div>
            <p className="click-hint">↑ Click the sphere to change mode</p>
            <div className="stats">
              <CountStat target={2}  suffix="+" label="Years"/>
              <CountStat target={40} suffix="%" label="Faster QA"/>
              <CountStat target={10} suffix="K+" label="Users Tested"/>
            </div>
          </div>

        </div>
      </div>
    </main>
  )
}
